import type { ReactNode } from "react";

interface SectionShellProps {
  id: string;
  /** 見出しの左に置くアイコン */
  icon: ReactNode;
  heading: ReactNode;
  /** 見出しの下の一行（支援領域の「経営のライフサイクルに寄り添う支援」など） */
  note?: ReactNode;
  /** 節の頭に敷く写真。無ければ出さない */
  photo?: { src: string };
  className?: string;
  children: ReactNode;
}

/**
 * 各節の外枠。見出しの列と本文の列に分かれ、見出しは広い画面では貼り付く。
 * 節ごとの進行は --section-progress（useHomeMotion が入れる）を .section-track が読む。
 */
export const SectionShell = ({
  id,
  icon,
  heading,
  note,
  photo,
  className = "",
  children,
}: SectionShellProps) => (
  <section id={id} className={`section ${className}`.trim()} aria-labelledby={`${id}-title`}>
    {photo && (
      <div className="photo-band">
        <img src={photo.src} alt="" loading="lazy" decoding="async" />
      </div>
    )}
    <div className="section-inner">
      <header className="section-heading" data-reveal>
        <span className="section-icon">{icon}</span>
        <h2 id={`${id}-title`}>{heading}</h2>
        {note && <p>{note}</p>}
        <span className="section-track" aria-hidden="true">
          <i />
        </span>
      </header>
      <div className="section-body">{children}</div>
    </div>
  </section>
);
